import { Dispatch, SetStateAction } from 'react';

import { Button, Stack, styled } from '@mui/material';

import { IcClose } from '@/assets/images';
import { RenderFormField } from '@/components';
import { colors } from '@/theme/variables';

import { CustodyActions } from '../data';
import { useKasePropertyContext } from '../PropertyContext';

export const BulkActionsRoot = styled(Stack)(() => ({
  backgroundColor: colors.grey[100],
  padding: '10px',
  color: colors.white,
  borderRadius: '8px',
  '.selectWrapper>div': {
    marginBottom: 0,
  },
  '.MuiInputBase-root': {
    backgroundColor: `${colors.white}!important`,
    minWidth: '200px',
  },
}));

type ChangeCustodyBtnStyleProps = {
  paddingRight: number;
  marginRight: number;
  borderRight: string;
  borderTopRightRadius: number;
};

interface BulkActionsControlPopupProps {
  showCustodyActions: boolean;
  changeCustodyBtnStyles: ChangeCustodyBtnStyleProps;
  setShowCustodyActions: Dispatch<SetStateAction<boolean>>;
  bulkActionTypeOptions: { label: string; value: string }[];
  currentActionType: string;
  actionTargetItems: any;
  handleClick: (action: keyof typeof CustodyActions) => void;
  actionTarget: keyof typeof CustodyActions;
  preventChangeCustody: boolean;
}

export const BulkActionsControlPopup = ({
  showCustodyActions,
  changeCustodyBtnStyles,
  setShowCustodyActions,
  bulkActionTypeOptions,
  currentActionType,
  actionTargetItems,
  actionTarget,
  handleClick,
  preventChangeCustody,
}: BulkActionsControlPopupProps) => {
  const { resetBulkSelections } = useKasePropertyContext();

  return (
    <Stack
      flexDirection="row"
      sx={{
        width: showCustodyActions ? '100%' : 'unset',
      }}
    >
      {!preventChangeCustody && (
        <Button
          variant="text"
          sx={{
            color: 'white',
            ...(showCustodyActions && changeCustodyBtnStyles),
          }}
          onClick={() => setShowCustodyActions(true)}
        >
          Change custody
        </Button>
      )}
      {showCustodyActions ? (
        <>
          <Stack flexDirection="row" justifyContent="space-between" gap={3}>
            <RenderFormField
              sx={{ mb: 0 }}
              type="select"
              name="bulkActionType"
              items={bulkActionTypeOptions}
            />
            {currentActionType &&
              currentActionType !== 'check_in' &&
              currentActionType !== 'moveLocation' && (
                <RenderFormField
                  sx={{ mb: 0 }}
                  type="select"
                  name="bulkActionTarget"
                  items={
                    actionTargetItems[
                      currentActionType as keyof typeof actionTargetItems
                    ]
                  }
                />
              )}
          </Stack>
          <Stack flexDirection="row" marginLeft="auto">
            <Button
              variant="contained"
              color="error"
              sx={{ marginLeft: 'auto' }}
              onClick={() =>
                handleClick(
                  currentActionType === 'check_in'
                    ? CustodyActions.CHECK_IN
                    : currentActionType === 'moveLocation'
                    ? CustodyActions.MOVE_LOCATION
                    : actionTarget,
                )
              }
            >
              Apply
            </Button>

            <Button
              variant="text"
              onClick={() => {
                resetBulkSelections();
              }}
            >
              <IcClose style={{ color: colors.error.main }} />
            </Button>
          </Stack>
        </>
      ) : (
        <>
          <Button
            variant="text"
            style={{ color: 'white' }}
            onClick={() => handleClick(CustodyActions.PRINT_BULK_CUSTODY_LOGS)}
          >
            Print custody logs
          </Button>
          <Button
            variant="text"
            style={{ color: 'white' }}
            onClick={() => handleClick(CustodyActions.PRINT_LABELS)}
          >
            Print label
          </Button>

          <Button
            variant="text"
            onClick={() => {
              resetBulkSelections();
            }}
            sx={{ position: 'absolute', right: 0 }}
          >
            <IcClose style={{ color: colors.error.main }} />
          </Button>
        </>
      )}
    </Stack>
  );
};
